import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PaginationInstance} from 'ngx-pagination';
import {tipoAcaoEnum} from 'src/app/api/module/erp/shared/enumerable/tipo-acao-enum';
import {CustomValidators} from '../../validators/custom-validators';

export enum ComponentesEnum {
  LISTAGEM = 99,
}
@Component({
  selector: 'app-tabela',
  templateUrl: './tabela.component.html',
  styleUrls: ['./tabela.component.scss'],
})
export class TabelaComponent implements OnInit, OnChanges {
  @Input() listaTabela = new Array<any>();
  @Input() colunasTabela = new Array<any>();
  @Input() idConfig: string;
  @Input() corTabela: string = 'bg-table-geia';
  @Input() componente: number;
  @Input() ehTelaBeneficiario: boolean = false;
  @Input() mostrarColunaStatus: boolean = false;
  @Input() mostrarColunaAcao: boolean = false;
  @Input() somenteLeitura: boolean = false;
  @Input() podeCadastrarEditar: boolean = false;
  @Input() podeVisualizar: boolean = false;
  @Input() podeInativar: boolean = false;
  @Input() podeExcluir: boolean = false;
  @Input() podeReprocessarReajuste: boolean = false;
  @Input() podeReverterReajuste: boolean = false;
  @Input() mostrarBotaoHistorico: boolean = false;
  @Input() componenteSemInativar: boolean = false;
  @Input() config!: PaginationInstance | undefined;
  @Input() mostrarPaginacao: boolean = false;
  @Input() podeDownload: boolean = false;

  @Output() emitirAcaoBotao = new EventEmitter<any>();

  tipoAcao = tipoAcaoEnum;
  componentesEnum = ComponentesEnum;

  mostraBtnEditar: boolean = false;
  mostrarBtnInativar: boolean = false;
  mostrarBtnVisualizar: boolean = false;
  mostrarBtnExcluir: boolean = false;
  mostrarBtnSelecionar: boolean = false;
  mostrarBtnDowload: boolean = false;
  mostrarBtnReprocessar: boolean = false;
  mostrarBtnReverter: boolean = false;

  constructor() {}

  ngOnInit(): void {
    if (!this.config) {
      this.config = {
        id: this.idConfig || 'tabela_sem_paginacao_' + Math.random().toString(36).substring(2, 9),
        currentPage: 1,
        itemsPerPage: 999999, // Um número alto para listar tudo na mesma página caso venha populado
        totalItems: this.listaTabela?.length || 0,
      };
    }
    this._componenteSemInativar();
    this.mostrarBtnAcao();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.config) {
      this.config = {
        id: this.idConfig || 'tabela_sem_paginacao_' + Math.random().toString(36).substring(2, 9),
        currentPage: 1,
        itemsPerPage: 999999,
        totalItems: this.listaTabela?.length || 0,
      };
    } else if (this.config.itemsPerPage >= 999999 || (!this.mostrarPaginacao && (!this.config.totalItems || this.config.totalItems === 0))) {
      this.config.totalItems = this.listaTabela?.length || 0;
    }
    this._componenteSemInativar();
    this.mostrarBtnAcao();
  }

  retornaValorCampo(item: any, campo: string) {
    if (!item || !campo) return '-';

    // Se for o contador ou botão, não retorna texto
    if (campo === 'contador' || campo === 'btnValues') return '';

    let valor: any;

    // Verifica se o campo pede navegação por ponto (ex: product.productName)
    if (campo.includes('.')) {
      valor = campo.split('.').reduce((obj, key) => (obj ? obj[key] : undefined), item);
    } else {
      // Acesso direto para campos simples (ex: name, cpf, rg)
      valor = item[campo];
    }

    return valor !== null && valor !== undefined && valor !== '' ? valor : '-';
  }

  onTablePageChange(event: any) {
    this.config.currentPage = event;

    this.emitirAcaoBotao.emit({
      acao: tipoAcaoEnum.PAGINACAO,
      pagina: event,
    });
  }

  botaoAcaoClicado(index: number, id: string, status: boolean, acao: tipoAcaoEnum, item: any) {
    let enviarDados = {index: index, id: id, status: status, acao: acao, item: item};
    this.emitirAcaoBotao.emit(enviarDados);
  }

  mostrarBtnAcao() {
    this.mostraBtnEditar = this.podeCadastrarEditar;
    this.mostrarBtnInativar = this.podeInativar;
    this.mostrarBtnVisualizar = this.podeVisualizar;
    this.mostrarBtnExcluir = this.podeExcluir;
    this.mostrarBtnReprocessar = this.podeReprocessarReajuste;
    this.mostrarBtnReverter = this.podeReverterReajuste;
    this.mostrarBtnDowload = this.podeDownload;
    // this.mostrarBtnExcluir = this.podeExcluir;
    //deixar estes intes serem controlados especificamente pelos inputs e nao pelo compont criando um monte de if
    //ex: amanha criar tela de Historico(table) ai teremos que vir aqui e inserir ela.
    //este component tem que se gerenciar apartir dos inputs. e matar todos os if.

    if (this.componente == ComponentesEnum.LISTAGEM) {
      this.mostraBtnEditar = this.podeCadastrarEditar;
      this.mostrarBtnInativar = this.podeInativar;
      this.mostrarBtnVisualizar = this.podeVisualizar;
      this.mostrarPaginacao = true;
    }
  }

  _componenteSemInativar(): boolean {
    if (this.componenteSemInativar && !this.ehTelaBeneficiario) {
      this.podeExcluir = true;
      this.mostrarBtnExcluir = true;
      return true;
    }
    return false;
  }

  adicionarBadge(value: any): boolean {
    if (value == 'coparticipation' || value == 'accommodation') {
      return true;
    }
    return false;
  }

  contarItens(itens: any): number {
    // Conta o titular (sempre 1) + o número de dependentes
    return 1 + (itens?.length || 0);
  }

  calcularIdadePessoa(item: any, campo: string): number {
    if (!item || !campo) return 0;

    if (campo == 'age') {
      const idade = CustomValidators.calcularIdadePessoa(item.birthDate);
      return idade;
    }
  }

  retornaValorTooltip(item: any, coluna: any): string {
    if (coluna.pipe === 'date' || coluna.pipe === 'dateTime') {
      const valorData = this.retornaValorCampo(item, coluna.campo);
      return this.formatarData(valorData, coluna.pipe === 'dateTime');
    }

    const valorPadrao = this.retornaValorCampo(item, coluna.campo);
    return valorPadrao !== null && valorPadrao !== undefined ? String(valorPadrao) : '';
  }

  private formatarData(valor: any, incluirHora: boolean = false): string {
    try {
      const data = new Date(valor);

      if (isNaN(data.getTime())) return valor;

      const opcoes: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      };

      if (incluirHora) {
        opcoes.hour = '2-digit';
        opcoes.minute = '2-digit';
      }

      return new Intl.DateTimeFormat('pt-BR', opcoes).format(data);
    } catch (e) {
      return valor;
    }
  }

  mostrarBotaoInativar(item: any): boolean {
    return !!item?.id && this.mostrarBtnInativar && !this.somenteLeitura && (!this.ehTelaBeneficiario || item?.active);
  }

  temPropriedadeLockout(item: any): boolean {
    return item && 'lockoutEnabled' in item;
  }
  todosSelecionados(): boolean {
    if (!this.listaTabela || this.listaTabela.length === 0) return false;
    return this.listaTabela.every(item => item.selecionado);
  }

  toggleTodos(event: any) {
    const checked = event.target.checked;
    this.listaTabela.forEach(item => {
      item.selecionado = checked;
    });
    this.emitirAcaoBotao.emit({acao: 'SELECAO_TODOS', status: checked});
  }

  onCheckboxChange(item: any) {
    this.emitirAcaoBotao.emit({acao: 'SELECAO_LINHA', item: item});
  }

  obterClasseBordaBotao(nomeBotao: string, item: any): string {
    const botoesVisiveis: string[] = [];
    if (this.mostraBtnEditar) botoesVisiveis.push('editar');
    if (this.mostrarBtnVisualizar && item?.canViewOccurrence !== false) botoesVisiveis.push('visualizar');
    if (
      this.mostrarBtnReprocessar &&
      (item?.processingDate == null || item?.processingDate === '-' || item?.hasProcessingDate === false)
    )
      botoesVisiveis.push('reprocessar');
    if (this.mostrarBtnReverter) botoesVisiveis.push('reverter');
    if (this.mostrarBotaoHistorico) botoesVisiveis.push('historico');
    if (this.mostrarBtnDowload) botoesVisiveis.push('download');
    if (this.mostrarBotaoInativar(item)) botoesVisiveis.push('inativar');
    if (this.mostrarBtnExcluir && !this.somenteLeitura) botoesVisiveis.push('excluir');
    if (item?.mostrarBtnAcao) botoesVisiveis.push('selecionar');

    if (botoesVisiveis.length <= 1) {
      return 'bordas-arredondadas';
    }
    const index = botoesVisiveis.indexOf(nomeBotao);
    if (index === 0) {
      return 'bordas-esquerda-arredondadas';
    }
    if (index === botoesVisiveis.length - 1) {
      return 'bordas-direita-arredondadas';
    }
    return 'bordas-retas';
  }
}
